import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone:true,name: 'ImagePipe'})
export class ImagePipe implements PipeTransform {
  transform(img: string, dir: string, ext: string): string {
    if(!dir) {
      throw new Error(`no dir found [${dir}]...`)
    }
    if(!img) {
      throw new Error(`no img found [${img}]...`)
    }
    if(!ext) {
      throw new Error(`no ext found [${ext}]...`)
    }

    return `./assets/img/${dir}/${img}.${ext}`;
  }
}
